export function CreateCapricornCsvCtrl ($uibModalInstance, $scope, $translate, $window, API, integrations, messages) {

  $scope.end_date     = '';
  $scope.integrations = integrations;
  $scope.start_date   = '';

  $scope.download = function () {
    $window.open(`${API.url}/capricorn/download_csv/${$scope.start_date}/${$scope.end_date}`);

    messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.CAPRICORN.DOWNLOADED_UPLOAD_TO_CAPLINK'), 'success');

    $uibModalInstance.close();
  };
}